import {
  collection,
  getDocs,
  query,
  setDoc,
  where,
  doc,
} from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { db } from "./firebase-config";

function Events(props) {
  const [events, setEvents] = useState([]);
  console.log(props.Events);
  let event = [];
  const sendEmail = async (events) => {
    const q = query(collection(db, "Events"), where("Name", "==", events.Name));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      // doc.data() is never undefined for query doc snapshots
      console.log(doc.id, " => ", doc.data());
    });

    console.log(events);
  };
  const getEvents = async () => {
    await getDocs(collection(db, "Events")).then((querySnapshot) => {
      var evnt = [];
      querySnapshot.forEach((doc) => {
        evnt.push(doc.data());
        event.push(doc.data());
        console.log(doc.data());
      });
      setEvents(evnt);
    });
  };
  useEffect(() => {
    setEvents([]);
    getEvents();
    console.log(events);
  }, []);
  return (
    <div className="events">
      <h1>Events</h1>
      <div className="event-cont">
        {events.map((val) => {
          let dis = false;
          if (val.people.indexOf(props.Doc) !== -1) {
            dis = true;
          }
          return (
            <div
              style={{
                width: "80%",
                height: "50vh",
                display: "flex",
                flexDirection: "row",
                border: "1px solid black",
                borderRadius: "30px",
                margin: "0 auto",
                alignItems: "center",
                backgroundColor: "white",
                marginTop: "20px",
              }}
            >
              <img
                src={val.ThumbNail}
                alt=""
                style={{ width: "50%", height: "100%", borderRadius: "30px" }}
              />
              <div
                style={{
                  width: "50%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <h1 style={{ fontSize: "30px" }}>✨{val.Name}</h1>
                <h2>Aim♻️-{val.Aim}</h2>
                <h2>Location🌍-{val.Location}</h2>
                <h2>Date📆-{val.Date}</h2>
                <button
                  style={{
                    width: "150px",
                    height: "40px",
                    border: "2px solid magenta",
                    borderRadius: "20px",
                    color: "white",
                    backgroundColor: "orange",
                    position: "relative ",
                    left: "250px",
                    top: "50px",
                  }}
                  onClick={async () => {
                    const q = query(
                      collection(db, "Events"),
                      where("Name", "==", val.Name)
                    );
                    const querySnapshot = await getDocs(q);
                    querySnapshot.forEach((docs) => {
                      // doc.data() is never undefined for query doc snapshots
                      console.log(docs.data().people);
                      let data = docs.data().people;
                      data.push(props.Doc.email);
                      console.log(data);
                      setDoc(
                        doc(db, "Events", docs.id),
                        { people: data },
                        { merge: true }
                      );
                    });

                    console.log(events);

                    const response = await fetch(
                      `http://localhost:5000/events/email`,
                      {
                        headers: {
                          "Content-Type": "application/json",
                        },
                        method: "POST",
                        body: JSON.stringify([
                          {
                            event: val.name,
                            loc: val.Location,
                            email: props.Doc.email,
                          },
                        ]),
                      }
                    );
                    console.log(response);
                  }}
                  disabled={dis}
                >
                  Join Event
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Events;
